
import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';


class CardListSection extends Component {
  render() {
    const {
      title,
      className,
      children,
    } = this.props;
    return (
      <div className={classnames('CardListSection_Title', className)}>
        {title}
        {children}
      </div>
    );
  }
}

CardListSection.propTypes = {
  title: PropTypes.any.isRequired,
  children: PropTypes.any,
  className: PropTypes.string,
};

CardListSection.defaultProps = {
  className: '',
  children: null,
};

export default CardListSection;
